import { Stack, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type TicketUsageStatusProps = {
  ticketUnusedCount?: number
  ticketUsedCount?: number
  purchasedNumber?: number
}
export const TicketUsageStatus: Organism<TicketUsageStatusProps> = ({
  ticketUnusedCount,
  ticketUsedCount,
  purchasedNumber,
}) => {
  const { t } = useTranslation('consoleEventDetail')
  return (
    <Stack
      flex={1}
      alignItems="center"
      spacing={2}
      sx={{
        p: 4,
        bgcolor: 'grey.50',
        borderRadius: '6px',
      }}
    >
      <Typography variant="subtitle1" align="left" width="100%">
        {t('usageStatus', '使用状況')}
      </Typography>
      <Stack spacing={1} alignItems="center">
        <Stack direction="row" alignItems="center">
          <Typography variant="h3" color="secondary.main">
            {ticketUsedCount || '-'}
          </Typography>
          <Typography variant="overline" color="warning.main" pt={1}>
            ({ticketUnusedCount || '-'})
          </Typography>
          <Typography variant="h6">/</Typography>
          <Typography variant="subtitle2" pt={1}>
            {purchasedNumber || '-'}
          </Typography>
        </Stack>
        <Typography variant="overline" color="text.secondary">
          {t('usageStatusNote', '使用済み(未使用)/購入数')}
        </Typography>
      </Stack>
    </Stack>
  )
}
